import React, { useState, useEffect, useCallback } from 'react';
import { TimeSliceGenerator } from '../../utils/TimeSliceGenerator'
import { TimeSliceViewType, TimeSliceWindow } from '../../models/TimeSlice'; // Assuming you put types in a 'types' folder
import { TimePickerProps, TimePicker } from '../../components/ui/TimePicker';

const timeSliceGenerator = new TimeSliceGenerator();

const MyTimeSliceComponent: React.FC = () => {
  const [selectedView, setSelectedView] = useState<TimeSliceViewType>('24h');
  const [roundFlag, setRoundFlag] = useState(false); // New state for the flag
  const [sliceData, setSliceData] = useState<TimeSliceWindow | null>(null);

  const generateAndDisplaySlice = (
    view: TimeSliceViewType,
    round: boolean,
    customDate?: Date
  ) => {
    const data = timeSliceGenerator.generateTimeSlice(view, customDate, round);
    setSliceData(data);
    console.log(
      `Generated Slice for ${view} ${round ? '(Rounded)' : ''} at ${
        customDate?.toISOString() || 'now'
      }:`,
      data
    );
  };

  // Effect to generate initial slice on mount and when view/roundFlag changes
  React.useEffect(() => {
    generateAndDisplaySlice(selectedView, roundFlag);
  }, [selectedView, roundFlag]); // Add roundFlag to dependencies

  // Example of using a custom reference date
  const handleCustomDateSlice = () => {
    // Current time is Tuesday, July 1, 2025 at 8:10:15 PM PDT
    const customRef = new Date('2025-07-01T20:10:15-07:00'); // Specific time in PDT for testing
    generateAndDisplaySlice(selectedView, roundFlag, customRef);
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Time Slice Generator</h1>

      <div className="py-4 px-4">
        <label>Select View Type: </label>
        <select
          value={selectedView}
          onChange={(e) => setSelectedView(e.target.value as TimeSliceViewType)}
        >
          <option value="7d">7 Days (Daily)</option>
          <option value="24h">24 Hours (3-Hour Increments)</option>
          <option value="2h">2 Hours (15-Minute Increments)</option>
        </select>
      </div>
      <br />
    <label>
        <input
        type="checkbox"
        checked={roundFlag}
        onChange={(e) => setRoundFlag(e.target.checked)}
        />
        Round to Nearest Upper Interval
    </label>
    <br />      
      <div className="py-4 px-4 space-x-8">
        <button className="deriq-action-button" onClick={() => generateAndDisplaySlice(selectedView, roundFlag)}>
        Generate for Now
        </button>
        <button className="deriq-action-button" onClick={handleCustomDateSlice}>
        Generate for Custom Date
        </button>
      </div>

      {sliceData && (
        <div
          style={{ marginTop: '20px', border: '1px solid #ccc', padding: '10px' }}
        >
          <h3>Generated Time Slice Data:</h3>
          <p>
            <strong>View Type:</strong> {selectedView}{' '}
            {roundFlag ? '(Rounded)' : ''}
          </p>
          <p>
            <strong>Reference Time:</strong>{' '}
            {sliceData.startTime ? new Date(sliceData.startTime).toLocaleString() : 'N/A'}{' '}
            to{' '}
            {sliceData.endTime ? new Date(sliceData.endTime).toLocaleString() : 'N/A'}
          </p>
          <p>
            <strong>Start Time (ISO):</strong> {sliceData.startTimeStr}
          </p>
          <p>
            <strong>End Time (ISO):</strong> {sliceData.endTimeStr}
          </p>
          <p>
            <strong>Increment (minutes):</strong> {sliceData.incrementMinutes}
          </p>
        </div>
      )}

      <br/>
      <TimePickerSample />
    </div>
  );
};

export default MyTimeSliceComponent;

// --- Example Usage in a Parent Component ---
const TimePickerSample = () => {
  const [myChosenTime, setMyChosenTime] = useState('09:00');
  const [anotherTime, setAnotherTime] = useState('13:30');

  const handleTimeChange = (time: string) => {
    setMyChosenTime(time);
    console.log('Selected Time:', time);
  };

  return (
    <div style={{ marginTop: '20px', border: '1px solid #ccc', padding: '10px' }}>
      <h3>Time Picker Example</h3>

      <div>
        <p>My Main Time:</p>
        <TimePicker
          value={myChosenTime}
          intervalMinutes={30} // Custom interval of 30 minutes
          onChange={handleTimeChange}
          id="main-time-picker"
        />
        <p>Current selected time: {myChosenTime}</p>
      </div>

      <div style={{ marginTop: '20px' }}>
        <p>Another Time:</p>
        <TimePicker
          value={anotherTime}
          intervalMinutes={180} // Custom interval of 30 minutes
          onChange={setAnotherTime}
          id="another-time-picker"
        />
        <p>Another selected time: {anotherTime}</p>
      </div>
    </div>
  );
};

// (e.g., App.tsx)

// import React, { useState } from 'react';
// import TimePicker from './TimePicker'; // Adjust path as needed



// export default App;